<ion-toolbar color="--ion-color-light-teal-2" class="ion-text-center border-b text-pl">
    <span *ngIf="parentData != [] && parentRowData == undefined">Select Type</span>
    <span *ngIf="parentRowData != [] && parentData == undefined">Select Clinical Block</span>
    <fa-icon *ngIf="parentRowData != [] && parentData == undefined" class="infoCircle" (click)="presentPopover($event)" [icon]="faInfoCircle"></fa-icon>
    <ion-buttons slot="end">
        <ion-button id="exit-btn" (click)="dismiss()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>

<ion-content class="white p-0">
    <ion-grid>
        <ion-row class="white p-0">
            <ion-col size="12" class="p-0">
                <ion-row>
                    <ion-col size="12" class="ion-text-center p-0">
                        <ion-text>
                            <ul class="iti-list">
                                <div *ngIf="parentData">
                                    <li
                                        *ngFor="let dataType of parentData; let i = index"
                                        id="{{ dataType }}"
                                        [attr.tabindex]="i"
                                        (click)="setValue(dataType, 'PType')"
                                    >
                                        <span>{{ dataType }} </span>
                                        <p *ngIf="dataType === 'Observership'">
                                            An In-person clinical experience limited to observation and simulation of the practice of medicine. Great for
                                            Graduates.
                                        </p>
                                        <p *ngIf="dataType === 'Dentistry'">
                                            Clinical experience opportunities for DDS, DMD, and other dental degree students and graduates.
                                        </p>
                                        <p *ngIf="dataType === 'Hands-On'">
                                            An in-person clinical experience that includes patient-focused activities under physician supervision subject to
                                            local rules and regulations.
                                        </p>
                                        <p *ngIf="dataType === 'Nursing'">
                                            Practicums are open to nursing students and graduates; some programs are only open to specific degree types (see
                                            program descriptions).
                                        </p>
                                        <p *ngIf="dataType === 'Pre-Med Shadowing'">
                                            Experience the practice of medicine by shadowing a physician in a specialty of interest to see if it is a good fit.
                                        </p>
                                        <p *ngIf="dataType === 'Research'">
                                            Observerships or hands-on experiences with a research component and possibility of publication.
                                        </p>
                                        <p *ngIf="dataType === 'Virtual'">
                                            Attend your rotation over the internet from anywhere around the globe. Includes Clinical Focused (telemedicine &
                                            virtual on-site) and Education/Research focused experiences.
                                        </p>
                                        <p *ngIf="dataType === 'Virtual Pre-Med Shadowing'">
                                            Real-time clinical shadowing over the internet from anywhere. Shadow a physician via a telemedicine platform or
                                            through virtual on-site rotation.
                                        </p>
                                    </li>
                                </div>

                                <div *ngIf="parentRowData">
                                    <li *ngFor="let dataTime of parentRowData; let i = index" [attr.tabindex]="i" (click)="setValue(dataTime, 'PTime')">
                                        <div style="display: flex; justify-content: space-between; font-size: 0.7rem">
                                            <span class="session-item">{{ dataTime?.session }}</span>
                                            <span class="available-item" *ngIf="dataTime.available > 1">Seats: {{ dataTime?.available }}</span>
                                            <span class="available-item" *ngIf="dataTime.available === 1">Seat: {{ dataTime?.available }}</span>
                                        </div>
                                        <div style="display: flex; justify-content: space-between; font-size: 0.7rem">
                                            <span
                                                >Price: ${{ fieldOfStudy === 'Nurse Practitioner' ? dataTime?.hourlyprice : dataTime?.price
                                                }}{{ fieldOfStudy === 'Nurse Practitioner' ? '/hr' : '' }}</span
                                            >
                                            <span> </span>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </ion-text>
                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>

<ion-footer class="ion-no-border ion-text-right border-t">
    <ion-button class="btncta ion-margin-bottom add-width outline" id="submit-cancel-btn" mode="md" fill="solid" color=" " type="button" (click)="dismiss()">
        Cancel
    </ion-button>
    <ion-button
        class="btncta ion-margin-bottom add-width"
        id="submit-selection-btn"
        mode="md"
        fill="solid"
        color="secondary"
        type="button"
        (click)="ctaClick()"
    >
        Select
    </ion-button>
</ion-footer>
